import Platform from '../utils/Platform';

const Event = {
  NONE: 0,
  START_CONNECTION: 1,
  FINISH_CONNECTION: 2,
  CONNECTION_STARTED: 50,
  CONNECTION_FAILED: 51,
  CONNECTION_FINISHED: 52,
  START_SESSION: 100,
  FINISH_SESSION: 102,
  SESSION_STARTED: 150,
  SESSION_FINISHED: 152,
  SESSION_FAILED: 153,
  TASK_REQUEST: 200,
  TTS_SENTENCE_START: 350,
  TTS_SENTENCE_END: 351,
  TTS_RESPONSE: 352,
  CodeClientError: 45000000, //客户端通用错误
  CodeServerError: 55000000, //服务端通用错误
  CodeSessionError: 55000001, //服务端session错误
  CodeInvalidReqError: 45000001 //客户端请求参数错误
};
var messageJSON = null;
var audioParams = null;

const recv = () => {
  messageJSON = null; // 清空消息
  return new Promise((resolve) => {
    const checkMessage = () => {
      if (messageJSON) {
        resolve(messageJSON); // 当有消息时，resolve
        messageJSON = null; // 清空消息
      } else {
        setTimeout(checkMessage, 50); // 如果没有消息，50毫秒后再检查一次
      }
    };
    checkMessage(); // 启动消息检查
  });
};

const create_start_connection_frame = () => {
  const frame = new Uint8Array(8); // 8字节的头部

  // 头部信息
  frame[0] = 0b00010001; // 协议版本(0001) + 头部大小(0001)
  frame[1] = 0b00010100; // Message type specific flags (假设为00010100)
  frame[2] = 0b00010000; // 序列化方法(JSON, 0001) + 无压缩(0000)
  frame[3] = 0b00000000; // Reserved

  // Event number (假设为START_CONNECTION事件)
  const eventType = new ArrayBuffer(4);
  new DataView(eventType).setInt32(0, 1, false); // 假设START_CONNECTION的值为1
  frame.set(new Uint8Array(eventType), 4);

  // Payload
  const payload = new TextEncoder().encode(JSON.stringify({}));
  const payloadLen = new Uint8Array(4);
  new DataView(payloadLen.buffer).setUint32(0, payload.length, false);

  // 组合最终的帧
  const finalFrame = new Uint8Array(frame.length + payloadLen.length + payload.length);
  finalFrame.set(frame);
  finalFrame.set(payloadLen, frame.length);
  finalFrame.set(payload, frame.length + payloadLen.length);
  console.log('finalFrame.buffer', finalFrame.buffer);
  return finalFrame.buffer;
  // 返回Base64编码的数据
  // return wx.arrayBufferToBase64(finalFrame.buffer);
};

const parse_frame = (frame) => {
  if (!(frame instanceof ArrayBuffer)) {
    throw new Error(`frame is not ArrayBuffer: ${frame}`);
  }

  const view = new DataView(frame);
  const header = new Uint8Array(frame, 0, 4);

  const version = header[0] >> 4;
  const headerSize = (header[0] & 0x0f) * 4;
  const messageType = header[1] >> 4;
  const flags = header[1] & 0x0f;
  const serializationMethod = header[2] >> 4;
  const compressionMethod = header[2] & 0x0f;

  const event = view.getUint32(4);

  let payloadStart = headerSize;
  // Reserved 留空（0b0000 0000）
  payloadStart += 4;

  let sessionId = null;
  if ([0b0001, 0b1001, 0b1011].includes(messageType)) {
    // 完整请求/响应或仅音频
    const sessionIdLen = view.getUint32(payloadStart);
    sessionId = new TextDecoder().decode(new Uint8Array(frame, payloadStart + 4, sessionIdLen));
    payloadStart += 4 + sessionIdLen;
  }

  let jsonData = null;
  let payload = null;
  if (event == Event.TTS_RESPONSE) {
    const payloadLen = view.getUint32(payloadStart);
    payload = new Uint8Array(frame, payloadStart + 4, payloadLen);
  } else {
    // console.log(`protocol event: ${event}`);
    payload = new Uint8Array(frame, payloadStart + 4);
    try {
      const payloadStr = new TextDecoder('utf-8').decode(payload);
      // console.log(`protocol message:${payloadStr}`);
      jsonData = JSON.parse(payloadStr);
      // console.log('protocol jsonData:', jsonData);
    } catch (e) {
      console.log(`protocol parse json error:${e}`);
    }
  }

  return {
    version: version,
    messageType: messageType,
    serializationMethod: serializationMethod,
    compressionMethod: compressionMethod,
    event: event,
    sessionId: sessionId,
    payload: jsonData || payload
  };
};

const getLang = (lang) => {
  if (lang) {
    switch (lang) {
      case 'cn':
        return 'zh-cn';
      case 'es':
        return 'es-mx';
      default:
        return lang;
    }
  }
  return '';
};

const createStartSessionFrame = (sessionId, speaker, lang) => {
  let metaData;
  if (audioParams == null) {
    metaData = {
      event: 100,
      req_params: {
        speaker: speaker,
        additions: JSON.stringify({
          explicit_language: getLang(lang)
        }),
        audio_params: { format: Platform.OS == 'ios' ? 'mp3' : 'pcm', sample_rate: 48000 }
      }
    };
  } else {
    // 语速，取值范围[-50,100]，100代表2.0倍速，-50代表0.5倍数
    let speed = Math.round((audioParams.speedRatio - 1) * 100);
    metaData = {
      event: 100,
      req_params: {
        speaker: speaker,
        additions: JSON.stringify({
          explicit_language: getLang(lang)
        }),
        audio_params: {
          format: 'pcm',
          sample_rate: 24000,
          speech_rate: speed
        }
      }
    };
  }
  const bMetaDataJson = JSON.stringify(metaData);
  const frame = [];

  frame.push(0b00010001); // header
  frame.push(0b00010100); // event_number
  frame.push(0b00010000); // serialization
  frame.push(0b00000000); // reserved

  // event_type
  const eventType = Event.START_SESSION;
  frame.push((eventType >> 24) & 0xff);
  frame.push((eventType >> 16) & 0xff);
  frame.push((eventType >> 8) & 0xff);
  frame.push(eventType & 0xff);

  // session_id_len
  const sessionIdBytes = new TextEncoder().encode(sessionId);
  const sessionIdLength = sessionIdBytes.length;
  frame.push((sessionIdLength >> 24) & 0xff);
  frame.push((sessionIdLength >> 16) & 0xff);
  frame.push((sessionIdLength >> 8) & 0xff);
  frame.push(sessionIdLength & 0xff);
  frame.push(...sessionIdBytes); // 添加 session_id

  // meta_data_len
  const metaDataBytes = new TextEncoder().encode(bMetaDataJson);
  const metaDataLength = metaDataBytes.length;
  frame.push((metaDataLength >> 24) & 0xff);
  frame.push((metaDataLength >> 16) & 0xff);
  frame.push((metaDataLength >> 8) & 0xff);
  frame.push(metaDataLength & 0xff);
  frame.push(...metaDataBytes); // 添加 meta_data
  return new Uint8Array(frame);
};

const createFinishSessionFrame = (sessionId) => {
  const frame = [];
  frame.push(0b00010001); // header
  frame.push(0b00010100); // event_number
  frame.push(0b00010000); // serialization
  frame.push(0b00000000); // reserved

  // event_type
  const eventType = Event.FINISH_SESSION;
  frame.push((eventType >> 24) & 0xff);
  frame.push((eventType >> 16) & 0xff);
  frame.push((eventType >> 8) & 0xff);
  frame.push(eventType & 0xff);

  // session_id_len
  const sessionIdBytes = new TextEncoder().encode(sessionId);
  const sessionIdLength = sessionIdBytes.length;
  frame.push((sessionIdLength >> 24) & 0xff);
  frame.push((sessionIdLength >> 16) & 0xff);
  frame.push((sessionIdLength >> 8) & 0xff);
  frame.push(sessionIdLength & 0xff);
  frame.push(...sessionIdBytes); // 添加 session_id

  // 必须要有payload
  const payloadJson = JSON.stringify({});
  const payloadBytes = new TextEncoder().encode(payloadJson);
  const payloadLength = payloadBytes.length;
  frame.push((payloadLength >> 24) & 0xff);
  frame.push((payloadLength >> 16) & 0xff);
  frame.push((payloadLength >> 8) & 0xff);
  frame.push(payloadLength & 0xff);
  frame.push(...payloadBytes);
  return new Uint8Array(frame);
};

const createFinishConnectionFrame = () => {
  let frame = new Uint8Array(12); // 初始化一个字节数组，长度为12

  // header
  frame[0] = 0b00010001; // 17
  // event_number
  frame[1] = 0b00010100; // 20
  // serialization
  frame[2] = 0b00010000; // 16
  // reserved
  frame[3] = 0b00000000; // 0

  // 将 Event.FINISH_CONNECTION 替换为实际的事件类型值
  let eventType = Event.FINISH_CONNECTION; // 假设 Event.FINISH_CONNECTION 是一个已定义的常量
  const eventTypeBuffer = new ArrayBuffer(4);
  new DataView(eventTypeBuffer).setInt32(0, eventType, false); // 大端序
  frame.set(new Uint8Array(eventTypeBuffer), 4); // 将 event_type 放入 frame 中

  // session_id_len
  let payload = '{}'; // 假设 payload 是一个 JSON 字符串
  const payloadLen = payload.length;

  const payloadLenBuffer = new ArrayBuffer(4);
  new DataView(payloadLenBuffer).setUint32(0, payloadLen, false); // 大端序
  frame.set(new Uint8Array(payloadLenBuffer), 8); // 将 payload_len 放入 frame 中

  // payload
  const payloadBuffer = new TextEncoder().encode(payload); // 对 payload 进行编码
  frame = new Uint8Array([...frame, ...payloadBuffer]); // 将 payload 放入 frame 中

  return frame.buffer; // 返回 ArrayBuffer
};

const createTaskRequestFrame = (chunk, sessionId) => {
  const requestData = {
    event: Event.TASK_REQUEST,
    req_params: {
      text: chunk
      // text: chunk + 'cc'
    }
  };
  // console.log('发送请求内容', chunk, requestData);

  let bChunkJson = JSON.stringify(requestData);

  const frame = [];

  frame.push(0b00010001); // header
  frame.push(0b00010100); // event_number
  frame.push(0b00010000); // serialization
  frame.push(0b00000000); // reserved

  // event_type
  const eventType = Event.TASK_REQUEST;
  frame.push((eventType >> 24) & 0xff);
  frame.push((eventType >> 16) & 0xff);
  frame.push((eventType >> 8) & 0xff);
  frame.push(eventType & 0xff);

  // session_id_len
  const sessionIdBytes = new TextEncoder().encode(sessionId);
  const sessionIdLength = sessionIdBytes.length;
  frame.push((sessionIdLength >> 24) & 0xff);
  frame.push((sessionIdLength >> 16) & 0xff);
  frame.push((sessionIdLength >> 8) & 0xff);
  frame.push(sessionIdLength & 0xff);
  frame.push(...sessionIdBytes); // 添加 session_id

  // payload_len
  const chunkBytes = new TextEncoder().encode(bChunkJson);
  frame.push((chunkBytes.length >> 24) & 0xff);
  frame.push((chunkBytes.length >> 16) & 0xff);
  frame.push((chunkBytes.length >> 8) & 0xff);
  frame.push(chunkBytes.length & 0xff);
  frame.push(...chunkBytes); // 添加 payload
  return new Uint8Array(frame);
  // return new Uint8Array([
  //   17, 20, 16, 0, 0, 0, 0, 200, 0, 0, 0, 15, 116, 101, 115, 116, 95, 115, 101, 115, 115, 105, 111,
  //   110, 95, 105, 100, 0, 0, 0, 78, 123, 34, 101, 118, 101, 110, 116, 34, 58, 32, 50, 48, 48, 44,
  //   32, 34, 114, 101, 113, 95, 112, 97, 114, 97, 109, 115, 34, 58, 32, 123, 34, 116, 101, 120, 116,
  //   34, 58, 32, 34, 92, 117, 57, 48, 97, 51, 92, 117, 53, 99, 51, 49, 92, 117, 52, 101, 55, 48, 92,
  //   117, 55, 50, 53, 57, 92, 117, 53, 50, 51, 55, 92, 117, 53, 53, 98, 100, 34, 125, 125
  // ]);
  // return new Uint8Array([
  //   17, 20, 16, 0, 0, 0, 0, 200, 0, 0, 0, 15, 116, 101, 115, 116, 95, 115, 101, 115, 115, 105, 111,
  //   110, 95, 105, 100, 0, 0, 0, 66, 123, 34, 101, 118, 101, 110, 116, 34, 58, 32, 50, 48, 48, 44,
  //   32, 34, 114, 101, 113, 95, 112, 97, 114, 97, 109, 115, 34, 58, 32, 123, 34, 116, 101, 120, 116,
  //   34, 58, 32, 34, 92, 117, 54, 55, 48, 57, 92, 117, 52, 101, 48, 48, 92, 117, 53, 50, 48, 54, 92,
  //   117, 55, 48, 101, 100, 34, 125, 125
  // ]);
};

const sendSocketMessage = (data) => {
  return new Promise((resolve) => {
    try {
      global.ws.sendSocketMessage({
        data: data,
        success: function () {
          resolve();
        },
        fail: function (err) {
          console.error('消息发送失败', err);
        }
      });
    } catch (error) {
      console.log('网络异常', error);
    }
  });
};

// 示例 sendTask 函数
async function sendTaskFrame(sessionId, textGenerator) {
  for (const chunk of textGenerator) {
    const taskFrame = createTaskRequestFrame(chunk, sessionId);
    sendSocketMessage(taskFrame);
  }
}

function receiveResponse(response) {
  const frame = parse_frame(response);
  switch (frame.event) {
    case Event.TTS_RESPONSE:
      // 带上 sessionId，供上层过滤被打断的旧 Session 数据
      return { event: frame.event, sessionId: frame.sessionId, payload: frame.payload };
    case Event.SESSION_FINISHED:
    case Event.FINISH_CONNECTION:
      return {
        event: frame.event,
        sessionId: frame.sessionId
      };
    default:
      return { event: frame.event, sessionId: frame.sessionId, payload: frame.payload };
  }
}

function setAudioParams(params) {
  audioParams = params;
}

export default {
  setAudioParams,
  parse_frame,
  create_start_connection_frame,
  createStartSessionFrame,
  createFinishSessionFrame,
  createFinishConnectionFrame,
  createTaskRequestFrame,
  sendTaskFrame,
  sendSocketMessage,
  receiveResponse,
  recv,
  Event
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/audio/protocol.js